export { default } from './info';
